import { messages as frenchMessages } from './fr';

export default {
  fr: frenchMessages,
};
